module.exports = __webpack_public_path__ + "img/img-news-letter.a5d9b19d.jpg";